import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_NEW + '/powerbi'

const powerbi = axios.create({
  baseURL
})

interceptorsSetup(powerbi)

export default class Powerbi {
  static async getPowerBiToken (powerBiID) {
    try {
      const res = await powerbi.get(baseURL + '/reports/' + powerBiID + '/generateToken')
      return res.data
    } catch {
      throw Error('Could not get report')
    }
  }
  static async getPowerBIReports () {
    try {
      const res = await powerbi.get(baseURL + '/reports')
      return res.data
    } catch {
      throw Error('Could not get reports')
    }
  }
}
